import ApiService from "./ApiService";
import AuthService from "./AuthService";

class FilterService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = "ru";
        this._autocompleteBuyers = "/filters/search/buyer";
        this._autocompleteCompanies = "/filters/search/company";
        this._layoutAdminProducts = "/filters/layout/admin-products";
        this._layoutAttributesUrl = "/filters/layout/attributes";
        this._layoutCategoriesUrl = "/filters/layout/categories";
        this._layoutPartnerManufacturerShowcasesUrl = "/filters/layout/partner-manufacturer-showcases";
        this._layoutCategoryUrl = "/filters/layout/category";
        this._layoutProfileBasketUrl = "/filters/layout/profile-basket";
        this._layoutProfileProducts = "/filters/layout/profile-products";
        this._layoutProfileSalesUrl = "/filters/layout/profile-sales";
        this._layoutRegionUrl = "/filters/layout/region";
        this._orderStatusUrl = "/filters/order-status";
        this._layoutUsersUrl = "/filters/layout/users";
        this._layoutOrdersUrl = "/filters/layout/orders";
    }

    getBaseHeaders() {
        const langHeader = this.getLangHeader();
        const authHeader = this._authService.getAuthHeader();

        return { ...authHeader, ...langHeader };
    }

    async searchBuyer(val) {
        return this.postResource(
            this._autocompleteBuyers,
            { name: val },
            this.getLangHeader()
        );
    }

    async searchCompany(val) {
        return this.postResource(
            this._autocompleteCompanies,
            { name: val },
            this.getLangHeader()
        );
    }

    async getOrderStatuses() {
        return this.getResource(this._orderStatusUrl);
    }

    /*async getAttributeLayout(valueId) {
        return this.postResource(this._layoutAttributeUrl, {id: valueId}, this.getBaseHeaders())
    }*/

    async getAttributesLayout() {
        return this.postResource(
            this._layoutAttributesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    async getCategoriesLayout() {
        return this.postResource(
            this._layoutCategoriesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    async getPartnerManufacturerShowcasesLayout() {
        return this.postResource(
            this._layoutPartnerManufacturerShowcasesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    async getAdminProductsLayout(params) {
        return this.postResource(
            this._layoutAdminProducts,
            params,
            this.getBaseHeaders()
        );
    }

    async getCategoryLayout(categoryId) {
        const params = { categoryId };

        return this.postResource(
            this._layoutCategoryUrl,
            params,
            this.getBaseHeaders()
        );
    }

    async getGeneralLayout(id, filterKey) {
        if (filterKey === "attribute") {
            return this.postResource(
                this._layoutAttributeUrl,
                { id: id },
                this.getBaseHeaders()
            );
        } else if (filterKey === "category") {
            const params = { categoryId: id };

            return this.postResource(
                this._layoutCategoryUrl,
                params,
                this.getBaseHeaders()
            );
        } else if (filterKey === "region") {
            return this.postResource(
                this._layoutRegionUrl,
                { id: id },
                this.getBaseHeaders()
            );
        }
    }

    async getRegionLayout(regionId) {
        return this.postResource(
            this._layoutRegionUrl,
            { id: regionId },
            this.getBaseHeaders()
        );
    }

    async getProfileBasketLayout() {
        return this.postResource(
            this._layoutProfileBasketUrl,
            {},
            this.getBaseHeaders()
        );
    }

    async getProfileProductsLayout() {
        return this.postResource(
            this._layoutProfileProducts,
            {},
            this.getBaseHeaders()
        );
    }

    async getProfileSalesLayout() {
        return this.postResource(
            this._layoutProfileSalesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    async getUsersLayout(params) {
        return this.postResource(
            this._layoutUsersUrl,
            params,
            this.getBaseHeaders()
        );
    }

    async getOrdersLayout(params) {
        return this.postResource(
            this._layoutOrdersUrl,
            params,
            this.getBaseHeaders()
        );
    }
}

const filterService = new FilterService(AuthService);

export default filterService;
